import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import femmeVelo from "../../assets/femme-velo1.png";

const InfoSection = () => {
  const { t } = useTranslation("garanties/InfoSection");

  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2, mt: 10 }}>
      <Box
        sx={{
          maxWidth: "1200px",
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 6,
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        {/* Texte à gauche */}
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontWeight: 900,
              fontSize: { xs: "2rem", md: "3rem" },
              color: "#000",
              textAlign: "left",
              mb: 3,
            }}
          >
            {t("title.part1")}{" "}
            <Box component="span" sx={{ color: "#FFC22F" }}>
              {t("title.highlight")}
            </Box>
          </Typography>

          <Typography
            sx={{
              fontSize: "1.2rem",
              fontWeight: 400,
              color: "#444",
              textAlign: "left",
              mb: 2,
            }}
          >
            {t("paragraph1.p1a")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph1.safeForBike")}
            </Box>
            {t("paragraph1.p1b")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph1.softMobility")}
            </Box>
            {t("paragraph1.p1c")}{" "}
            {t("paragraph1.p1d")}{" "}
            {t("paragraph1.p1e")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph1.clear")}
            </Box>
            {", "}
            <Box component="span" fontWeight="bold">
              {t("paragraph1.accessible")}
            </Box>{" "}
            {t("paragraph1.p1f")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph1.noSurprise")}
            </Box>
            .
          </Typography>

          <Typography
            sx={{
              fontSize: "1.1rem",
              fontWeight: 400,
              color: "#444",
              textAlign: "left",
            }}
          >
            {t("paragraph2.p2a")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph2.theft")}
            </Box>
            {t("paragraph2.p2b")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph2.damage")}
            </Box>{" "}
            {t("paragraph2.p2c")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph2.breakdown")}
            </Box>
            {t("paragraph2.p2d")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph2.lightMind")}
            </Box>
            {t("paragraph2.p2e")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph2.realNeeds")}
            </Box>{" "}
            {t("paragraph2.p2f")}{" "}
            <Box component="span" fontWeight="bold">
              {t("paragraph2.noComplexity")}
            </Box>
            .
          </Typography>
        </Box>

        {/* Image à droite - cachée en dessous de 1015px */}
        <Box
          sx={{
            flex: 1,
            maxWidth: "380px",
            width: "100%",
            display: {
              xs: "none",
              sm: "none",
              md: "flex",
              "@media (max-width:1015px)": {
                display: "none",
              },
            },
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "70%",
              overflow: "hidden",
              borderBottomRightRadius: "120px",
            }}
          >
            <Box
              component="img"
              src={femmeVelo}
              alt="Femme avec vélo"
              sx={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InfoSection;